{
  "3 months": "3 mois",
  "6 months": "6 mois",
  "A stream is complete with a PO and a tech lead. The DAR appoints them.": "Un stream est complet avec un PO et un tech lead. La DAR les nomme.",
  "Action": "Action",
  "Action not updated": "Action non mise à jour",
  "Add a slot": "Ajouter un passage",
  "Add an action": "Ajouter une action",
  "Add it to a session in the planning.": "Ajouter une séance dans le planning.",
  "Align the stream or the planning.": "Aligner la fiche ou le planning.",
  "All": "Toutes",
  "Ask the owner for an update.": "Demander un point au porteur.",
  "Blocked": "Bloqué",
  "Blocking point, comments": "Point bloquant, commentaires",
  "Committee": "Comité IPC",
  "Committee date wanted": "Date IPC visée",
  "Committee planning": "Planning IPC",
  "Committee rhythm": "Rythme de passage",
  "Committee steering": "Pilotage des projets I&D",
  "Complete": "Complet",
  "Contacts": "Contacts",
  "Contacts: {{who}}": "Contacts : {{who}}",
  "Create the project or remove the slot.": "Créer la fiche projet ou retirer le passage.",
  "Current status: {{status}}. Confirm the delivery or reschedule.": "Statut actuel : {{status}}. Confirmer la livraison ou replanifier.",
  "Dashboard": "Tableau de bord",
  "Decisions": "Décisions",
  "Delete": "Supprimer",
  "Delete the session": "Supprimer la séance",
  "Delete these minutes?": "Supprimer ce compte rendu ?",
  "Due date": "Échéance",
  "Each slot is a project (or a free label). Leave the streams empty for the whole project.": "Chaque passage vise un projet (ou un libellé libre). Sans stream ciblé, c'est le projet entier.",
  "Edit the minutes": "Modifier le CR",
  "Following session, {{date}}: {{labels}}.": "Séance suivante, {{date}} : {{labels}}.",
  "Give them an owner and a due date in the minutes.": "Attribuer un porteur et une échéance dans les comptes rendus.",
  "In difficulty": "En difficulté",
  "In progress": "En cours",
  "Incomplete": "Incomplet",
  "Incomplete streams on {{count}} projects_one": "Streams incomplets sur {{count}} projet",
  "Incomplete streams on {{count}} projects_other": "Streams incomplets sur {{count}} projets",
  "Innovation & Development": "Innovation & Development",
  "Label": "Libellé",
  "Label (default: the project title)": "Libellé (par défaut : le nom du projet)",
  "Last minutes": "Dernier CR",
  "Last minutes: {{date}}": "Dernier CR : {{date}}",
  "Last · next": "Dernier · prochain",
  "Launch: {{date}}": "Lancement : {{date}}",
  "Loading the dashboard…": "Chargement du tableau de bord…",
  "Loading the minutes…": "Chargement des comptes rendus…",
  "Loading the planning…": "Chargement du planning…",
  "Minutes and actions": "Comptes rendus et actions",
  "Minutes are written after each committee slot.": "Un compte rendu se rédige après chaque passage en comité.",
  "Minutes not deleted": "Compte rendu non supprimé",
  "Minutes not saved": "Compte rendu non enregistré",
  "Minutes of the session": "CR de la séance",
  "Minutes saved": "Compte rendu enregistré",
  "Missing statuses on {{count}} projects_one": "Statuts manquants sur {{count}} projet",
  "Missing statuses on {{count}} projects_other": "Statuts manquants sur {{count}} projets",
  "Never planned": "Jamais programmé",
  "Never updated": "Jamais mis à jour",
  "New session": "Nouvelle séance",
  "Next committee": "Prochain IPC",
  "Next committee: {{date}}": "Prochain IPC : {{date}}",
  "Next slot": "Prochain passage",
  "No committee slot planned": "Aucun passage IPC prévu",
  "No contact entered.": "Contacts non renseignés.",
  "No explanation entered in the blocking point.": "Aucune explication saisie dans le point bloquant.",
  "No minutes yet": "Aucun compte rendu",
  "No slot planned": "Aucun passage prévu",
  "No slot planned for this session.": "Aucun passage prévu pour cette séance.",
  "No status": "Sans statut",
  "No status. Delivered or late?": "Aucun statut. Livré ou en retard ?",
  "No tracked project yet: import the committee tool or create a project.": "Aucun projet suivi : importez l'outil IPC ou créez un projet.",
  "No upcoming session.": "Aucune séance à venir.",
  "None": "Aucun",
  "Not given": "Non renseignée",
  "Not planned": "Non planifié",
  "Not seen enough": "Pas assez vu",
  "Not started": "Non démarré",
  "Note": "Note",
  "On track": "Au rythme",
  "One committee every Friday. Each project comes back at the rhythm its priority sets.": "Un comité chaque vendredi. Chaque projet repasse au rythme que fixe sa priorité.",
  "Open": "Ouvrir",
  "Outside the list": "Hors référentiel",
  "Outside the list (free label)": "Hors référentiel (libellé libre)",
  "Overall status": "Statut global",
  "Owner": "Porteur",
  "PO": "PO",
  "PO + TL": "PO + TL",
  "PO + TL missing": "PO + TL manquants",
  "Participants": "Participants",
  "Participants: {{who}}": "Participants : {{who}}",
  "Plan one": "En planifier une",
  "Planned launch": "Lancement prévu",
  "Portfolio": "Portefeuille",
  "Priority": "Priorité",
  "Priority {{priority}}. Add it to a session in the planning.": "Priorité {{priority}}. Ajouter une séance dans le planning.",
  "Projects per session": "Projets par séance",
  "Red weather without a comment.": "Météo rouge sans commentaire.",
  "Remove the slot": "Retirer le passage",
  "Rhythm": "Rythme",
  "Roles": "Rôles",
  "Roles of “{{title}}”": "Rôles de « {{title}} »",
  "Roles saved": "Rôles enregistrés",
  "See the project": "Voir le projet",
  "Seen too often": "Vu trop souvent",
  "Session deleted": "Séance supprimée",
  "Session not deleted": "Séance non supprimée",
  "Session not saved": "Séance non enregistrée",
  "Session of {{date}}": "Séance du {{date}}",
  "Session saved": "Séance enregistrée",
  "Sessions": "Séances",
  "Sets the committee rhythm: P0 and P1 every 4 weeks, P2 every 6, P3 every 8.": "Fixe le rythme de passage en comité : P0 et P1 toutes les 4 semaines, P2 toutes les 6, P3 toutes les 8.",
  "Slot {{number}}": "Passage {{number}}",
  "Slots": "Passages",
  "Sponsor": "Sponsor",
  "Status of the action": "Statut de l'action",
  "Steer": "Piloter",
  "Steer “{{title}}”": "Piloter « {{title}} »",
  "Steering": "Pilotage",
  "Stream progress": "Avancement des streams",
  "Stream roles not saved": "Rôles du stream non enregistrés",
  "Stream tracking not saved": "Pilotage du stream non enregistré",
  "Summary": "Résumé",
  "Target rhythm: priority 0 and 1 every 4 weeks, priority 2 every 6, priority 3 and unranked every 8. “Not seen enough”: more than one and a half times the target between the last slot and the next. A session is loaded beyond 3 projects.": "Rythme cible : priorité 0 et 1 toutes les 4 semaines, priorité 2 toutes les 6, priorité 3 et sans priorité toutes les 8. « Pas assez vu » : plus d'une fois et demie la cible entre le dernier passage et le prochain. Une séance est chargée au-delà de 3 projets.",
  "Tech lead": "Tech lead",
  "The DAR appoints them on the project page.": "La DAR les nomme sur la fiche projet.",
  "The minutes and their actions are deleted.": "Le compte rendu et ses actions sont supprimés.",
  "To fill in at the next slot.": "À compléter au prochain passage.",
  "To watch": "À surveiller",
  "Today's committee": "IPC du jour",
  "Under control": "Sous contrôle",
  "Unranked": "Non classé",
  "Updated on {{date}}": "Mis à jour le {{date}}",
  "Weather": "Météo",
  "What each committee slot decided, and the actions that follow from it.": "Ce que chaque passage en comité a décidé, et les actions qui en découlent.",
  "What the DAR sees on its dashboard. Every change is dated.": "Ce que la DAR voit sur son tableau de bord. Chaque mise à jour est datée.",
  "Whole planning": "Tout le planning",
  "With open actions": "Avec actions ouvertes",
  "Write the minutes": "Rédiger le CR",
  "blocked streams": "streams bloqués",
  "due {{date}}": "échéance {{date}}",
  "loaded sessions": "séances chargées",
  "no owner": "sans porteur",
  "no slot": "aucun passage",
  "not seen enough": "pas assez vus",
  "open actions": "actions ouvertes",
  "outside the list": "hors référentiel",
  "past, minutes written": "passé, CR rédigé",
  "past, no minutes": "passé, sans CR",
  "projects on track": "projets au rythme",
  "seen too often": "vus trop souvent",
  "streams": "streams",
  "streams without PO + TL": "streams sans PO + TL",
  "streams without status": "streams sans statut",
  "target: every {{count}} weeks_one": "cible : toutes les {{count}} semaine",
  "target: every {{count}} weeks_other": "cible : toutes les {{count}} semaines",
  "tracked projects": "projets suivis",
  "upcoming": "à venir",
  "{{count}} actions without an owner._one": "{{count}} action sans porteur.",
  "{{count}} actions without an owner._other": "{{count}} actions sans porteur.",
  "{{count}} alerts to handle_one": "{{count}} alerte à traiter",
  "{{count}} alerts to handle_other": "{{count}} alertes à traiter",
  "{{count}} gaps between the stream and the planning_one": "{{count}} écart entre la fiche et le planning",
  "{{count}} gaps between the stream and the planning_other": "{{count}} écarts entre la fiche et le planning",
  "{{count}} late actions._one": "{{count}} action en retard.",
  "{{count}} late actions._other": "{{count}} actions en retard.",
  "{{count}} more alerts_one": "{{count}} autre alerte",
  "{{count}} more alerts_other": "{{count}} autres alertes",
  "{{count}} other signals_one": "{{count}} autre signal",
  "{{count}} other signals_other": "{{count}} autres signaux",
  "{{count}} slots_one": "{{count}} passage",
  "{{count}} slots_other": "{{count}} passages",
  "{{projects}} projects, {{streams}} streams, a committee slot every Friday. Alerts are recomputed on every change.": "{{projects}} projets, {{streams}} streams, un passage en comité chaque vendredi. Les alertes se recalculent à chaque mise à jour.",
  "{{where}} has no committee slot planned.": "{{where}} n'a aucun passage prévu au planning.",
  "{{where}} has not been updated for {{count}} days._one": "{{where}} n'a pas été mis à jour depuis {{count}} jour.",
  "{{where}} has not been updated for {{count}} days._other": "{{where}} n'a pas été mis à jour depuis {{count}} jours.",
  "{{where}} is blocked.": "{{where}} est bloqué.",
  "{{where}} is reported in difficulty.": "{{where}} est signalé en difficulté.",
  "{{where}}: committee date expected on {{date}}, not planned.": "{{where}} : date IPC prévue le {{date}}, planning sans passage.",
  "{{where}}: committee date expected on {{date}}, planned on {{planned}}.": "{{where}} : date IPC prévue le {{date}}, planning le {{planned}}.",
  "{{where}}: launch planned on {{date}}.": "{{where}} : lancement prévu le {{date}}.",
  "{{where}}: {{count}} streams without a PO and a tech lead._one": "{{where}} : {{count}} stream sans PO ni tech lead.",
  "{{where}}: {{count}} streams without a PO and a tech lead._other": "{{where}} : {{count}} streams sans PO ni tech lead.",
  "{{where}}: {{count}} streams without a status._one": "{{where}} : {{count}} stream sans statut.",
  "{{where}}: {{count}} streams without a status._other": "{{where}} : {{count}} streams sans statut.",
  "“{{label}}” is planned but is not a known project.": "« {{label}} » est planifié mais absent de la liste des projets."
}
